<script setup lang="ts">
import { storeToRefs } from 'pinia';
import useAuthStore from '@/src/store/auth';

const authStore = useAuthStore();
const { authError, isValidating } = storeToRefs(authStore);
</script>

<template>
  <v-container class="fill-height bg-grey-darken-4">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-6 text-center" color="grey-darken-3">
          <v-icon size="80" color="error" class="mb-4">
            mdi-shield-lock-outline
          </v-icon>
          
          <template v-if="isValidating">
            <h2 class="text-h5 mb-4">Validando acceso...</h2>
            <v-progress-circular indeterminate color="primary" size="48" />
          </template>
          
          <template v-else>
            <h2 class="text-h5 mb-4 text-error">Acceso Denegado</h2>
            <p class="text-body-1 mb-4">
              {{ authError || 'No tienes permiso para acceder a esta aplicación.' }}
            </p>
            <v-divider class="my-4" />
            <p class="text-body-2 text-grey">
              Si crees que esto es un error, contacta al administrador del sistema.
            </p>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
